import { ChevronDown, MoveRight, Menu, X } from "lucide-react";
import { useState } from "react";
import { images } from "../assets/assets";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const location = useLocation();

  const NavLinks = [
    { label: "Home", path: "/" },
    {
      label: "About Us",
      path: "/about",
      subMenu: [{ label: "Vision & Mission", path: "/vision-mission" }],
    },
    { label: "Services", path: "/services" },
    { label: "Doctors", path: "/doctors" },
    { label: "Appointment", path: "/appointment" },
    { label: "Blog", path: "/blog" },
    { label: "News", path: "/news" },
    { label: "Contact", path: "/contact" },
    { label: "Career", path: "/career" },
  ];

  return (
    <nav className="font-lato relative z-50 ">
      {/* Desktop Navbar */}
      <div className="flex items-center justify-between  px-4 md:px-8">
        {/* Logo */}
        <Link to="/">
          <img
            src={images.Logo}
            alt="logo"
            className="w-[70px] h-[70px] md:w-[100px] md:h-[100px]"
          />
        </Link>

        {/* Desktop Nav Links */}
        <div className="hidden xl:flex gap-3 items-center">
          {NavLinks.map((navItem, idx) => (
            <div key={idx} className="relative group">
              <Link
                to={navItem.path}
                className={`flex items-center text-[14px] font-medium py-2 px-2.5 rounded-[10px] transition-all duration-500 ease-in-out
                  ${
                    location.pathname === navItem.path
                      ? "bg-[#1975FF] text-white hover:bg-[#1560d4] active:bg-[#1050b8]"
                      : "text-black hover:bg-[#f0f4ff] hover:text-[#1975FF] active:bg-[#dde8ff]"
                  }`}
              >
                <span>{navItem?.label}</span>
                {navItem?.subMenu?.length > 0 && (
                  <ChevronDown
                    className={`w-4 h-4 ml-0.5 transition-transform duration-200 group-hover:rotate-180 ${
                      location.pathname === navItem.path ? "text-white" : "text-gray-600"
                    }`}
                  />
                )}
              </Link>

              {/* Desktop Submenu */}
              {navItem?.subMenu?.length > 0 && (
                <div className="absolute top-full left-0 mt-1 bg-white rounded-[10px] shadow-lg border border-gray-100 min-w-[180px] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 ease-in-out translate-y-1 group-hover:translate-y-0 z-50">
                  {navItem.subMenu.map((sub, subIdx) => (
                    <Link
                      key={subIdx}
                      to={sub.path}
                      className="block px-4 py-2.5 text-[13px] text-gray-700 hover:bg-[#f0f4ff] hover:text-[#1975FF] first:rounded-t-[10px] last:rounded-b-[10px] transition-colors duration-150"
                    >
                      {sub.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}

          <Link
            to="/appointment"
            className="group bg-[#F59E0B] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] text-white ml-4 hover:bg-[#d97706] active:bg-[#b45309] transition-all duration-200 shadow-md hover:shadow-lg arrow-button"
          >
            Book Now{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight
                color="#000"
                className="rotate-[-38deg] w-4 h-4"
              />
            </span>
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="xl:hidden p-2 rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? (
            <X className="w-6 h-6 text-gray-800" />
          ) : (
            <Menu className="w-6 h-6 text-gray-800" />
          )}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileOpen && (
        <div
          className="xl:hidden fixed inset-0 bg-black/40 z-40"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Mobile Drawer */}
      <div
        className={`xl:hidden fixed top-0 right-0 h-full w-[280px] bg-white z-50 shadow-2xl transform transition-transform duration-300 ease-in-out overflow-y-auto ${
          mobileOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Drawer Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <Link to="/" onClick={() => setMobileOpen(false)}>
            <img src={images.Logo} alt="logo" className="w-[60px] h-[60px]" />
          </Link>
          <button
            onClick={() => setMobileOpen(false)}
            className="p-2 rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-colors"
          >
            <X className="w-5 h-5 text-gray-700" />
          </button>
        </div>

        {/* Mobile Links */}
        <div className="py-4 px-4 flex flex-col gap-1">
          {NavLinks.map((navItem, idx) => (
            <div key={idx}>
              <div className="flex items-center justify-between">
                <Link
                  to={navItem.path}
                  className={`flex-1 flex items-center text-[15px] font-medium py-2.5 px-3 rounded-[10px] transition-all duration-500
                    ${
                      location.pathname === navItem.path
                        ? "bg-[#1975FF] text-white"
                        : "text-gray-800 hover:bg-[#f0f4ff] hover:text-[#1975FF] active:bg-[#dde8ff]"
                    }`}
                  onClick={() => {
                    if (!navItem.subMenu) setMobileOpen(false);
                  }}
                >
                  {navItem.label}
                </Link>
                {navItem?.subMenu?.length > 0 && (
                  <button
                    onClick={() =>
                      setOpenSubMenu(openSubMenu === idx ? null : idx)
                    }
                    className="p-2 hover:bg-gray-100 rounded-lg ml-1 transition-colors"
                  >
                    <ChevronDown
                      className={`w-4 h-4 text-gray-600 transition-transform duration-200 ${
                        openSubMenu === idx ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                )}
              </div>

              {/* Mobile Submenu */}
              {navItem?.subMenu?.length > 0 && openSubMenu === idx && (
                <div className="ml-4 mt-1 flex flex-col gap-0.5">
                  {navItem.subMenu.map((sub, subIdx) => (
                    <Link
                      key={subIdx}
                      to={sub.path}
                      className="text-[14px] text-gray-600 py-2 px-3 rounded-[8px] hover:bg-[#f0f4ff] hover:text-[#1975FF] transition-colors"
                      onClick={() => setMobileOpen(false)}
                    >
                      {sub.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}

          <Link
            to="/appointment"
            className="mt-4 bg-[#F59E0B] rounded-[10px] py-2 pr-1 pl-4 flex items-center justify-between text-[15px] text-white hover:bg-[#d97706] active:bg-[#b45309] transition-colors shadow-md"
            onClick={() => setMobileOpen(false)}
          >
            Book Now{" "}
            <span className="p-2 bg-white rounded-full">
              <MoveRight color="#000" className="rotate-[-38deg] w-4 h-4" />
            </span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
